import { useSelector } from "react-redux";

export default function useUserHasAccess() {
  return useSelector(
    (state) => !!state.userProfile.data?.ec_access || !!state.userProfile.data?.im_access,
  );
}
